import { Card } from "react-bootstrap";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FaSave, FaTimes } from "react-icons/fa";
import { useState } from "react";
import { auth, db } from "../../services/firebaseConnection";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {toast} from 'react-toastify';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  setDoc
} from 'firebase/firestore';

export default function UserRegister({onCancel}) {
 
    const [teamZapShow, setTeamZapShow] = useState(false);
    

    async function handleSubmit(event) {
        event.preventDefault();
        const form = event.target;
        const formData = new FormData(form);
        
        // Aqui você pode processar os dados do formulário
        const userData = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            password: formData.get('password'),
            permission: formData.get('permission'),
            apiKey: formData.get('apiKey'),
            authDomain: formData.get('authDomain'),
            projectId: formData.get('projectId'),
            storageBucket: formData.get('storageBucket'),
            messagingSenderId: formData.get('messagingSenderId'),
            measurementId: formData.get('measurementId'),
            uid: null
        };

        toast.info("Criando usuário...");
        

        createUserWithEmailAndPassword(auth, userData.email, userData.password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                console.log("Usuário criado com sucesso:", user);
                // Aqui você pode salvar os dados adicionais do usuário no Firestore ou em outro lugar
                userData.uid = user.uid;
                addDataFireabaseUser(userData)
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error("Erro ao criar usuário:", errorCode, errorMessage);
                // Aqui você pode exibir uma mensagem de erro para o usuário
            });
    
    }

    async function addDataFireabaseUser(userData) {
        try {
            // Define o documento com o UID como ID
            const userDoc = doc(db, 'users', userData.uid);
            
            await setDoc(userDoc, {
                name: userData.name,
                phone: userData.phone,
                email: userData.email,
                permission: userData.permission,
                apiKey: userData.apiKey,
                authDomain: userData.authDomain,
                projectId: userData.projectId,
                storageBucket: userData.storageBucket,
                messagingSenderId: userData.messagingSenderId,
                measurementId: userData.measurementId
            });

            toast.success("Usuário criado com sucesso!");
        } catch (error) {
            console.error("Erro ao adicionar documento:", error);
            toast.error("Erro ao criar usuário: " + error.message);
        }
    }
 
    return (

    <Card className="mb-4 shadow-sm">
        <Card.Header as="h5">
            Criar Usuário
        </Card.Header>
        <Card.Body>
            <Form onSubmit={handleSubmit}>
                <Row >
                    <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nome *</Form.Label>
                        <Form.Control
                        name="name"
                        type="text"
                        placeholder="Digite o nome do usuário"
                        required
                        />
                    </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Telefone *</Form.Label>
                            <Form.Control
                                name="phone"
                                type="text"
                                placeholder="ex: (99) 99999-9999"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control
                                name="email"
                                type="email"
                                placeholder="Digite o seu email"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Senha *</Form.Label>
                            <Form.Control
                                name="password"
                                type="password"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Permissão *</Form.Label>
                            <Form.Select
                                name="permission"
                                required
                                >
                                <option value="usuario">Usuario</option>
                                <option value="administrador">Administrador</option>
                                <option value="cancelado">Cancelado</option>
                                </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Api Key *</Form.Label>
                            <Form.Control
                                name="apiKey"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>AuthDomain *</Form.Label>
                            <Form.Control
                                name="authDomain"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>ProjectId *</Form.Label>
                            <Form.Control
                                name="projectId"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>StorageBucket *</Form.Label>
                            <Form.Control
                                name="storageBucket"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>MessagingSenderId *</Form.Label>
                            <Form.Control
                                name="messagingSenderId"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>AppId *</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>MeasurementId *</Form.Label>
                            <Form.Control
                                name="measurementId"
                                type="text"
                                placeholder="*********"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
{/*                <hr/>
                <Row>
                    <div className="my-3 w-full d-flex align-items-center justify-content-between">
                        <hr className="flex-1 border-gray-300" />
                        <h3 className="text-muted ">TeamZap</h3>
                            <Form.Switch
                                label="Pago"
                                onChange={(e) => setTeamZapShow(e.target.checked)}
                                checked={teamZapShow}
                                className="ms-2"
                                size="sm"
                            />
                    </div>

                    {teamZapShow && (
                        <>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label> URL *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Digite o TeamZap ID"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Bearer Token *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Digite o TeamZap Token"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    )}

                </Row> */}
            <div className="d-flex justify-content-end mt-4">
                <Button variant="secondary" className="me-2" onClick={onCancel}>
                <FaTimes className="me-1" /> Cancelar
                </Button>
                <Button variant="success" type="submit">
                <FaSave className="me-2" /> Salvar
                </Button>
          </div>
            </Form>
        </Card.Body>
    </Card>
 );
}